<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useAuthStore from '@/store/AuthStore';
import gettext from '@/i18n/gettext';
import useNotionStore from '@/store/NotionStore';

const { $gettext } = gettext;
const authStore = useAuthStore();
const notionStore = useNotionStore();

const { softwareFeatures, preconfiguredRobots } = storeToRefs(notionStore);
const preconfiguredRobotsHeaders = computed(() => [
  {
    title: $gettext('Robot Name'),
    value: authStore.language === 'de' ? 'RobotName' : 'EnglishName',
  },
  { title: $gettext('Degrees of freedom'), value: 'Dof' },
  { title: $gettext('Arm reach (mm)'), value: 'ArmReachMm' },
  { title: $gettext('Payload (Kg)'), value: 'PayloadKg' },
  { title: $gettext('Robot weight (Kg)'), value: 'RobotWeightKg' },
  { title: $gettext('Configuration'), value: 'Configuration' },
  { title: $gettext('Build order'), value: 'BuildOrder' },
  {
    title: $gettext('Modules'),
    value: authStore.language === 'de' ? 'Module' : 'Modules',
  },
  // { title: $gettext('List price'), value: 'ListPrice' },
]);

const softwareFeaturesHeaders = computed(() => [
  {
    title: $gettext('Package'),
    value: authStore.language === 'de' ? 'Paket' : 'Package',
  },
  {
    title: $gettext('Description'),
    value: authStore.language === 'de' ? 'Beschreibung' : 'Description',
  },
  {
    title: $gettext('Bronze'),
    value: authStore.language === 'de' ? 'Bronze' : 'BronzeEnglish',
  },
  {
    title: $gettext('Silver'),
    value: authStore.language === 'de' ? 'Silber' : 'Silver',
  },
  {
    title: $gettext('Gold'),
    value: authStore.language === 'de' ? 'Gold' : 'GoldEnglish',
  },
]);
</script>
<template>
  <div v-if="false">
    <v-row class="mt-16">
      <v-col class="mb-4">
        <h1 class="display-2 text-center mb-3">
          {{ $gettext('Software packages') }}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xl="8" offset-xl="2">
        <v-data-table
          id="software-packages"
          class="resources-table"
          width="100%"
          items-per-page="-1"
          :items="softwareFeatures"
          :headers="softwareFeaturesHeaders"
        />
      </v-col>
    </v-row>
  </div>
  <v-row class="mt-16">
    <v-col class="mb-4">
      <h1 class="display-2 text-center mb-3">
        {{ $gettext('Preconfigured Robots') }}
      </h1>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" xl="8" offset-xl="2">
      <v-data-table
        :sort-by="[{ key: 'ListPrice', order: 'asc' }]"
        class="resources-table"
        width="100%"
        items-per-page="-1"
        :items="preconfiguredRobots"
        :headers="preconfiguredRobotsHeaders"
      >
        <template v-slot:[`item.RobotName`]="{ item }">
          <td style="min-width: 100px">{{ item.RobotName }}</td>
        </template>
        <template v-slot:[`item.EnglishName`]="{ item }">
          <td style="min-width: 120px">{{ item.EnglishName }}</td>
        </template>
        <template v-slot:[`item.BuildOrder`]="{ item }">
          <td style="min-width: 300px">{{ item.BuildOrder }}</td>
        </template>
        <template v-slot:[`item.Module`]="{ item }">
          <td style="min-width: 300px">{{ item.Modules }}</td>
        </template>
        <template v-slot:[`item.Modules`]="{ item }">
          <td style="min-width: 300px">{{ item.Modules }}</td>
        </template>
        <!--        <template v-slot:[`item.ListPrice`]="{ item }">-->
        <!--          <td class="font-weight-bold" style="min-width: 60px">-->
        <!--            {{ item.ListPrice }}-->
        <!--          </td>-->
        <!--        </template>-->
      </v-data-table>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.resources-table {
  .v-data-table-footer {
    display: none;
  }
}
</style>
